import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const ItemWrapper = styled.div<{ isPending?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;

  ${({ isPending }) =>
    isPending &&
    css`
      cursor: wait;
      p {
        pointer-events: none;
      }
    `}
`;

const BreadcrumbWrapperAdaptiveStyles = media.tablet`
  font-size: 14px;
`;

export const BreadcrumbWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  ${BreadcrumbWrapperAdaptiveStyles};
`;
